import "./RelatedSearchByTagStyles.scss";
import axios from "axios";
import $ from "jquery";
import { applyHoverZoomEffectWrapper, dnbComLog, evenHeights, isNotUndefined, isUndefined, LogSeverity } from "../FunctionsCore";
const relatedSearchByTag = (relatedSearchByTagParameter) => {
    $(() => {
        const $more = $(".more");
        let currentOffset = relatedSearchByTagParameter.propertiesMaxItemsInt;
        const equalHeightsSetup = () => {
            $(".related_list").each(function () {
                const $this = $(this);
                evenHeights($this, ".contenttype_area");
                evenHeights($this, ".title");
                evenHeights($this, ".author");
                evenHeights($this, ".description");
                evenHeights($this, ".tagline");
            });
        };
        const performNetworkRequest = (isMore) => {
            const parameters = {
                "ajax": true,
            };
            const contenttypeFilterSelectValueSelectValue = $(".contenttype_filter .select_value").data("selectValue");
            const contenttypeFilterSelectValueSelectValueIsNotUndefined = isNotUndefined(contenttypeFilterSelectValueSelectValue);
            const subcategoryFilterSelectValueSelectValue = $(".subcategory_filter .select_value").data("selectValue");
            const filtertags = "filtertags";
            if (isNotUndefined(subcategoryFilterSelectValueSelectValue)) {
                parameters["businessneedtag"] = subcategoryFilterSelectValueSelectValue;
                if (!contenttypeFilterSelectValueSelectValueIsNotUndefined) {
                    parameters[filtertags] = subcategoryFilterSelectValueSelectValue;
                }
            }
            if (contenttypeFilterSelectValueSelectValueIsNotUndefined) {
                parameters[filtertags] = contenttypeFilterSelectValueSelectValue;
            }
            if (isMore) {
                parameters["offset"] = currentOffset;
            }
            axios
                .get(relatedSearchByTagParameter.resourcePathHtmlExtensionRewritten, {
                "params": parameters
            })
                .then((ax) => {
                const data = ax.data;
                const $dataHtml = $("<html></html>").html(data);
                const outerHtml = $dataHtml.find(".new_results").get(0).outerHTML;
                const $relatedSearchByTagOffsetValueHiddenInput = $dataHtml.find(".relatedSearchByTagOffsetValueHiddenInput");
                const relatedSearchByTagOffsetValueHiddenInputValue = $relatedSearchByTagOffsetValueHiddenInput.val();
                let offsetString;
                if (isUndefined(relatedSearchByTagOffsetValueHiddenInputValue)) {
                    throw new Error();
                }
                else if (typeof relatedSearchByTagOffsetValueHiddenInputValue === "number") {
                    offsetString = window.String(relatedSearchByTagOffsetValueHiddenInputValue);
                }
                else if (typeof relatedSearchByTagOffsetValueHiddenInputValue === "string") {
                    offsetString = relatedSearchByTagOffsetValueHiddenInputValue;
                }
                else {
                    offsetString = relatedSearchByTagOffsetValueHiddenInputValue[0];
                }
                const offsetStringInt = window.Number.parseInt(offsetString);
                currentOffset = offsetStringInt;
                const $relatedSearchByTagSearchResults = $(".relatedSearchByTagSearchResults");
                if (isMore) {
                    $relatedSearchByTagSearchResults.append(outerHtml);
                }
                else {
                    $relatedSearchByTagSearchResults.hide().html(outerHtml).fadeIn(400);
                }
                $more.toggle(offsetStringInt > 0);
                equalHeightsSetup();
            })
                .catch((er) => dnbComLog(LogSeverity.ERROR, "Network request failed", er));
        };
        $more.find(".moreContentButton").on("click", () => performNetworkRequest(true));
        $(".select_menu_container")
            .on("mouseleave", function () {
            $(this).removeClass("active").removeClass("open");
        })
            .on("mouseover", function () {
            $(this).addClass("active").addClass("open");
        });
        $(".sub_filter_dynamic .select_menu_container li").on("click", function () {
            const $this = $(this);
            const $parents = $this.parents(".select_menu_container");
            $parents.find("li").removeClass("active");
            const $container = $parents.parents(".sub_filter_dynamic");
            const containerClass = $container.hasClass("subcategory_filter") ? "subcategory_filter" : "contenttype_filter";
            const thisHtml = $this.html();
            const value = $this.attr("name");
            // Set on both mobile and desktop versions
            const $child = $parents.find(".select_value").eq(0);
            const $containerClassSelectValue = $(`.${containerClass} .select_value`);
            if ($child.data("selectValue") === value) {
                $containerClassSelectValue.data("selectValue", "");
                $containerClassSelectValue.html("");
            }
            else {
                $containerClassSelectValue.data("selectValue", value);
                $containerClassSelectValue.html(`: ${thisHtml}`);
                $this.addClass("active");
            }
            performNetworkRequest(false);
        });
        $(".feed_filter_select_container.select_menu_container li").on("click", function () {
            const $this = $(this);
            const thisHtml = $this.html();
            const value = $this.attr("name");
            const $parents = $this.parents(".select_menu_container");
            $parents.find(".select_value").eq(0).html(thisHtml);
            window.location.href = value;
        });
        equalHeightsSetup();
        applyHoverZoomEffectWrapper(relatedSearchByTagParameter.applyHoverZoomEffectWrapperParameter);
    });
};
export { relatedSearchByTag };
